import { Typography } from '@mui/material';
import { formatDate } from '../../../utils/dates';
import WhoIsSigningViewer from './WhoIsSigningViewer';
import { SignatureContextType } from './contexts/signature.context.types';

type OrderContractModalFooterMobileProps = {
  hide: boolean;
  orderLabelText?: string;
  versionLabel?: string;
  contractInfo?: SignatureContextType.ContractInfo;
  dontBreak?: boolean;
  needToShowWhoIsSigning: boolean;
  whoIsSigning: string;
};

const OrderContractModalFooterMobile = ({
  hide,
  dontBreak,
  orderLabelText,
  versionLabel,
  contractInfo,
  needToShowWhoIsSigning,
  whoIsSigning,
}: OrderContractModalFooterMobileProps) => {
  if (hide) {
    return null;
  }

  if (dontBreak) {
    return (
      <>
        <WhoIsSigningViewer hide={!needToShowWhoIsSigning} whoIsSigning={whoIsSigning} />
        {(orderLabelText || versionLabel || contractInfo?.createdAt) && (
          <Typography variant="body2">
            {orderLabelText} {versionLabel} {formatDate(contractInfo?.createdAt, 'P p')}
          </Typography>
        )}
      </>
    );
  }

  return (
    <>
      <WhoIsSigningViewer hide={!needToShowWhoIsSigning} whoIsSigning={whoIsSigning} />
      {orderLabelText ||
        (versionLabel && (
          <Typography variant="body2">
            {orderLabelText} {versionLabel}
          </Typography>
        ))}
      {contractInfo?.createdAt && (
        <Typography variant="body2">{formatDate(contractInfo?.createdAt, 'P p')}</Typography>
      )}
    </>
  );
};

export default OrderContractModalFooterMobile;
